"use strict";

import { fetchRecords } from "@/api/manufacturer";
import getCacheBuster from "@/util/getCacheBuster";
import { memoize } from "lodash";

// import { createSelector } from "reselect";

const prefix = "catalog/manufacturer";

export const FETCH_STARTED = `${prefix}/FETCH_STARTED`;
export const FETCH_FAILED = `${prefix}/FETCH_FAILED`;
export const FETCH_ENDED = `${prefix}/FETCH_ENDED`;

const initialState = {
  isFetching: false,
  data: null,
  error: false,
};

const fetchEnd = (data) => ({ type: FETCH_ENDED, payload: data });
const fetchFail = () => ({ type: FETCH_FAILED });

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_STARTED:
      return {
        ...state,
        isFetching: true,
        error: false,
      };

    case FETCH_ENDED:
      return {
        ...state,
        data: action.payload,
        isFetching: false,
        error: false,
      };

    case FETCH_FAILED:
      return {
        ...state,
        isFetching: false,
        error: true,
      };

    default:
      return state;
  }
}

// async function fetchManufacturers() {
//   return async dispatch => {
//     try {
//       dispatch(fetchStart());
//       const data = await fetchRecords();
//       dispatch(fetchEnd(data));
//     } catch (err) {
//       dispatch(fetchFail());
//     }
//   };
// }

// memoize the api call, so it is called only once per cache buster
const fetchRecordsMemoized = memoize(function (cacheBuster, onSuccess, onError) {
  fetchRecords().then(onSuccess).catch(onError);
});

export function fetchManufacturersCached() {
  return async (dispatch) => {
    const cacheBuster = getCacheBuster();
    fetchRecordsMemoized(
      cacheBuster,
      (data) => dispatch(fetchEnd(data)),
      () => dispatch(fetchFail())
    );
  };
}

export * from "./selectors";
